import type { ToolContext } from '@/modules/Editor/managers/toolManager'

export const isMaskBrush = (context: ToolContext): boolean => {
  const annotationClass = context.editor.activeView.annotationManager.preselectedAnnotationClass

  return !!annotationClass?.annotation_types.includes('mask')
}
